// extracted by mini-css-extract-plugin
export default {"root":"SectionJobTypes_root__48qYD","typesOfJob":"SectionJobTypes_typesOfJob__UiwOb","item":"SectionJobTypes_item__8c-hO","itemTitle":"SectionJobTypes_itemTitle__k+pav"};